<template>
  <el-dialog
    class="dialog-container"
    title="三包索赔单导出"
    :visible.sync="dialogVisible"
    width="550px"
    append-to-body
  >
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="供应商名称" prop="supplierName">
        <el-input
          v-model="form.supplierName"
          placeholder="请输入"
          style="width: 100%"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商代码" prop="supplierCode">
        <el-input
          v-model="form.supplierCode"
          placeholder="请输入"
          style="width: 100%"
        ></el-input>
      </el-form-item>
      <el-form-item label="正审时间" prop="dateRange">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="form.dateRange"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleSave">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDownloadFiles } from "@/util/downFile";
import { kdthreeGuaranteesExportApi } from "@/api/seek";

export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      saveLoading: false,
      form: this.getForm()
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init() {
      this.dialogVisible = true;
      this.form = this.getForm();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 获取表单对象
    getForm() {
      return {
        supplierName: "",
        supplierCode: "",
        dateRange: []
      };
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.saveLoading = true;
        try {
          const submitData = JSON.parse(JSON.stringify(this.form));
          if ((submitData.dateRange || []).length === 2) {
            submitData.auditPassTimeStart =
              submitData.dateRange?.[0] ;
            submitData.auditPassTimeEnd = submitData.dateRange?.[1] ;
          }
          delete submitData.dateRange;
          const res = await kdthreeGuaranteesExportApi(submitData);
          getDownloadFiles(res);
          if (res.fileName) {
            this.$DonMessage.success("导出成功！")
            this.dialogVisible = false;
          }
        } catch (error) {
          console.error(error);
        }
        this.saveLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep .el-dialog {
    border-radius: 5px;
    .el-dialog__header {
      height: 47px;
      padding: 0 12px 0 28px;
      border-bottom: 1px solid #efefef;
      border-radius: 5px 5px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-dialog__title {
        color: #333333;
        font-size: 18px;
      }

      .el-dialog__headerbtn {
        position: unset;
        font-size: 22px;
      }
    }
    .el-dialog__footer {
      text-align: center;
      border-top: 1px solid #efefef;
      padding: 20px 20px 26px 20px;
    }
  }
}
</style>
